module.exports = __webpack_public_path__ + "img/Lang_1.6fc65a78.png";